import * as React from 'react';
import { useEffect, useState } from 'react';

import AnimateHeight from 'react-animate-height';
import {
  ChapterCollapseLabel,
  ChapterCollapseToggle,
} from '../Styles/MaterialNavigation';
import { chevronIcon } from '../../../Assets/images/Icons';

type CollapseProps = {
  titleContent: JSX.Element;
  defaultOpen?: boolean;
  showArrow?: boolean;
};

type OpenStateHook = [boolean, React.Dispatch<React.SetStateAction<boolean>>];

const ChapterCollapse: React.FunctionComponent<CollapseProps> = ({
  children,
  titleContent,
  defaultOpen = false,
  showArrow = true,
}): JSX.Element => {
  const [open, setOpen]: OpenStateHook = useState(defaultOpen);
  const toggleOpen = (): void => setOpen(!open);
  const iconTransform = open ? 'rotate(180deg)' : 'rotate(0deg)';

  useEffect(() => {
    if (defaultOpen && !open) {
      setOpen(defaultOpen);
    }
  }, [defaultOpen]);

  return (
    <ChapterCollapseLabel>
      <ChapterCollapseToggle onClick={toggleOpen}>
        {showArrow && (
          <div className="icon" style={{ transform: iconTransform }}>
            {chevronIcon}
          </div>
        )}
        <div className="content">{titleContent}</div>
      </ChapterCollapseToggle>
      <AnimateHeight duration={500} height={open ? 'auto' : 0}>
        {children}
      </AnimateHeight>
    </ChapterCollapseLabel>
  );
};

export default ChapterCollapse;
